export type LegalRepresentativePopupState = {
    opened: boolean;
    form: {
        submitting: boolean;
    };
    legalRepresentative: {
        name: string;
        firstSurname: string;
        lastSurname: string;
        documentNumber: string;
        position: string;
    };
};

export const legalRepresentativePopupDefaultState: LegalRepresentativePopupState =
    {
        opened: false,
        form: {
            submitting: false,
        },
        legalRepresentative: {
            name: "",
            firstSurname: "",
            lastSurname: "",
            documentNumber: "",
            position: "",
        },
    };
